module.exports = __webpack_public_path__ + "img/logo-company.fa0f6d2a.png";